// @flow

/** Fields excluded from auto-populated lease charge tracking, highlighting, and banner logic. */
export const AUTO_FILLED_LEASE_CHARGE_FIELD_EXCEPTIONS = ['leasedRent'];

export const shouldTrackAutoFilledField = (fieldName: string): boolean =>
  !AUTO_FILLED_LEASE_CHARGE_FIELD_EXCEPTIONS.includes(fieldName);

export const filterTrackedAutoFilledFields = (
  fields: { [key: string]: boolean } = {},
): { [key: string]: boolean } =>
  Object.entries(fields).reduce((acc, [fieldName, value]) => {
    if (shouldTrackAutoFilledField(fieldName)) {
      acc[fieldName] = value;
    }
    return acc;
  }, {});

export const hasTrackedAutoFilledLeaseChargeField = (
  fields: { [key: string]: boolean } = {},
): boolean =>
  Object.entries(fields).some(
    ([fieldName, value]) => value && shouldTrackAutoFilledField(fieldName),
  );

export const mapApiAutoFilledLeaseChargeFields = (
  apiFields: Array<{ fieldName: string }> = [],
): { [key: string]: boolean } =>
  apiFields.reduce((acc, field) => {
    if (shouldTrackAutoFilledField(field.fieldName)) {
      acc[field.fieldName] = true;
    }
    return acc;
  }, {});
